module.exports = __webpack_public_path__ + "static/media/arrow.9fa322aa.svg";